import { render, staticRenderFns } from "./MediaLicenseAgreement.vue?vue&type=template&id=6b1acd16&scoped=true&"
import script from "./MediaLicenseAgreement.vue?vue&type=script&lang=js&"
export * from "./MediaLicenseAgreement.vue?vue&type=script&lang=js&"
import style0 from "./MediaLicenseAgreement.vue?vue&type=style&index=0&id=6b1acd16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1acd16",
  null
  
)

export default component.exports